import { Link } from 'react-router-dom';
import { FaTwitter, FaLinkedin, FaGithub, FaEnvelope, FaPhone, FaMapMarkerAlt, FaRocket, FaGraduationCap, FaInstagram, FaFacebook } from 'react-icons/fa';
import { HiAcademicCap, HiSparkles } from 'react-icons/hi';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white border-t border-gray-800 mt-auto">
      <div className="container-responsive py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand Section */}
          <div className="lg:col-span-1">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-white rounded-xl flex items-center justify-center text-white text-xl font-bold mr-4 shadow-sm border border-gray-100">
                 <img src="gaplify_logo-2.png" alt="Gaplify Logo" className='rounded-md'/>
              </div>
              <div>
               
                <h3 className="text-2xl font-bold bg-white bg-clip-text text-transparent from-blue-600 to-indigo-700">Gaplify</h3>
                <p className="text-sm text-gray-400 font-medium">AI Career Bridge</p>
              </div>
            </div>
            <p className="text-gray-300 mb-4 leading-relaxed">
              Empowering learners with AI-driven guidance and personalized career development resources.
            </p>
            <p className="text-gray-400 italic text-sm">
              "Bridge the Gap to Your Dream Career."
            </p>
            
            {/* Social Links */}
            <div className="flex space-x-4 mt-6">
              <a href="https://x.com/gaplify" className="w-10 h-10 bg-gray-800 hover:bg-white rounded-lg flex items-center justify-center text-gray-400 hover:text-primary-600 transition-all duration-200 border border-gray-700 hover:border-white shadow-sm hover:shadow-glow hover:-translate-y-1">
                <FaTwitter className="w-5 h-5" />
              </a>
              <a href="https://www.linkedin.com/company/gaplify" className="w-10 h-10 bg-gray-800 hover:bg-white rounded-lg flex items-center justify-center text-gray-400 hover:text-primary-600 transition-all duration-200 border border-gray-700 hover:border-white shadow-sm hover:shadow-glow hover:-translate-y-1">
                <FaLinkedin className="w-5 h-5" />
              </a>
              <a href="https://www.instagram.com/gaplify/#" className="w-10 h-10 bg-gray-800 hover:bg-white rounded-lg flex items-center justify-center text-gray-400 hover:text-primary-600 transition-all duration-200 border border-gray-700 hover:border-white shadow-sm hover:shadow-glow hover:-translate-y-1">
                <FaInstagram className="w-5 h-5" />
              </a>
               <a href="https://www.facebook.com/people/Gaplify/61578976407569/" className="w-10 h-10 bg-gray-800 hover:bg-white rounded-lg flex items-center justify-center text-gray-400 hover:text-primary-600 transition-all duration-200 border border-gray-700 hover:border-white shadow-sm hover:shadow-glow hover:-translate-y-1">
                <FaFacebook className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-6 flex items-center text-white font-display">
              <FaRocket className="w-5 h-5 mr-2 text-primary-500" />
              Quick Links
            </h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-gray-300 hover:text-primary-400 transition-colors duration-200 flex items-center font-display">
                  <span className="w-2 h-2 bg-primary-500 rounded-full mr-3"></span>
                  Home
                </Link>
              </li>
              <li>
                <Link to="/skills-analysis" className="text-gray-300 hover:text-primary-400 transition-colors duration-200 flex items-center font-display">
                  <span className="w-2 h-2 bg-primary-500 rounded-full mr-3"></span>
                  Skills Analysis
                </Link>
              </li>
              <li>
                <Link to="/roadmap" className="text-gray-300 hover:text-primary-400 transition-colors duration-200 flex items-center font-display">
                  <span className="w-2 h-2 bg-primary-500 rounded-full mr-3"></span>
                  Learning Roadmap
                </Link>
              </li>
              <li>
                <Link to="/resource-hub" className="text-gray-300 hover:text-primary-400 transition-colors duration-200 flex items-center font-display">
                  <span className="w-2 h-2 bg-primary-500 rounded-full mr-3"></span>
                  Resource Hub
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-gray-300 hover:text-primary-400 transition-colors duration-200 flex items-center font-display">
                  <span className="w-2 h-2 bg-primary-500 rounded-full mr-3"></span>
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/mentors" className="text-gray-300 hover:text-primary-400 transition-colors duration-200 flex items-center font-display">
                  <span className="w-2 h-2 bg-primary-500 rounded-full mr-3"></span>
                  Mentors
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-lg font-semibold mb-6 flex items-center text-white font-display">
              <HiAcademicCap className="w-5 h-5 mr-2 text-secondary-500" />
              Company
            </h3>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-gray-300 hover:text-secondary-400 transition-colors duration-200 flex items-center font-display">
                  <span className="w-2 h-2 bg-secondary-500 rounded-full mr-3"></span>
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-secondary-400 transition-colors duration-200 flex items-center font-display">
                  <span className="w-2 h-2 bg-secondary-500 rounded-full mr-3"></span>
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/privacy-policy" className="text-gray-300 hover:text-secondary-400 transition-colors duration-200 flex items-center font-display">
                  <span className="w-2 h-2 bg-secondary-500 rounded-full mr-3"></span>
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms-and-conditions" className="text-gray-300 hover:text-secondary-400 transition-colors duration-200 flex items-center font-display">
                  <span className="w-2 h-2 bg-secondary-500 rounded-full mr-3"></span>
                  Terms & Conditions
                </Link>
              </li>
             
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-6 flex items-center text-white font-display">
              <FaGraduationCap className="w-5 h-5 mr-2 text-accent-500" />
              Contact Us
            </h3>
            <ul className="space-y-4">
              <li className="flex items-start">
                <FaEnvelope className="w-5 h-5 text-accent-500 mr-3 mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-white font-medium font-display">Email</p>
                  <p className="text-gray-400 text-sm">gaplify@gmail.com</p>
                </div>
              </li>
            
              <li className="flex items-start">
                <FaMapMarkerAlt className="w-5 h-5 text-accent-500 mr-3 mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-white font-medium font-display">Address</p>
                  <p className="text-gray-400 text-sm">Pune , India</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        
        

        {/* Bottom Bar */}
        <div className="mt-8 pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              &copy; {currentYear} Gaplify. All rights reserved.
            </p>
            <div className="flex space-x-6 text-sm">
            <Link to="/privacy-policy" className="text-gray-400 hover:text-primary-400 transition-colors font-display">
                Privacy Policy
              </Link>
              <Link to="/terms-and-conditions" className="text-gray-400 hover:text-primary-400 transition-colors font-display">
                Terms of Service
              </Link>
              <Link to="/cookie-policy" className="text-gray-400 hover:text-primary-400 transition-colors font-display">
                Cookie Policy
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;